<template>
  <div class="template-page about">
    <div class="intro" :style="{ backgroundImage: 'url('+ about.bannerUrl +')' }">
      <div class="bg-line container"></div>
      <div
        class="container container-small content content-image"
        :style="{ backgroundImage: 'url(' + about.bannerUrl + ')' }"
      >
        <div>
          <div class="container-small">
            <h4 class="part-title-small white">{{about.title}}</h4>
          </div>
        </div>
        <app-back-btn :backInfo="backInfo"></app-back-btn>
      </div>
    </div>
    <div class="page-content container">
      <div class="container-small">
        <div class="about" v-html="about.content"></div>
        <div class="info">
          <app-tags></app-tags>
          <app-share></app-share>
        </div>
      </div>
    </div>
    <BottomSection></BottomSection>
  </div>
</template>
<script>
import Share from "@/components/shared/Share";
import Tags from "@/components/shared/Tags.vue";
import Back_btn from "@/components/shared/Back-btn";

const url = process.env.VUE_APP_URL;
const BottomSection = () => import("@/components/shared/BottomSection");

export default {
  data() {
    return {
      backInfo: {
        name: "back to main page",
        path: "/",
      },
    };
  },
  computed: {
    about() {
      return this.$store.getters.aboutPage;
    },
  },
  methods: {
    aboutPage() {
      this.axios
        .get(url + "/about_pages", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("aboutPage", payload);
          this.videoOverlay();
        });
    },
    videoOverlay() {
      document.querySelectorAll(".about p > img").forEach((element) => {
        if (!element.classList.contains("video-done") && !element.alt == "") {
          element.classList.add("video-done");
          var cloneElement = element.cloneNode(true);
          var newDiv = document.createElement("div");
          var elemAlt = element.alt;
          newDiv.classList.add("photo-video");

          newDiv.innerHTML =
            "<div class='preview'><a href='javascript:void(0);' class='btn-wrapper'><span class='btn btn_play circle' aria-hidden='true'><span class='icon arrow'></span></span></a></div>";

          newDiv.appendChild(cloneElement);
          element.parentNode.insertBefore(newDiv, element);
          element.classList.add("video-done");
        }
      });
    },
    modalOpen(element) {
      var payload = {};
      payload.videoLink = element.toElement.closest(".preview").nextSibling.alt;
      payload.show = true;
      this.$store.commit("showModal", payload);
      const scrollY = document.documentElement.style.getPropertyValue(
        "--scroll-y"
      );
      const body = document.body;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}`;
    },
  },
  mounted() {
    this.aboutPage();
    setTimeout(
      function () {
        var payload = {};
        document.querySelectorAll(".btn-wrapper").forEach((element) => {
          element.addEventListener("click", this.modalOpen);
        });
      }.bind(this),
      1500
    );
  },
  updated() {
    this.videoOverlay();
  },
  components: {
    "app-share": Share,
    "app-tags": Tags,
    "app-back-btn": Back_btn,
    BottomSection,
  },
};
</script>
<style lang="scss" scoped>
.content-image {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media only screen and (max-width: 768px) {
    background-image: none !important;
  }
}
.video-done {
  display: none;
}
.video {
  .btn-wrapper {
    display: block;
  }
}
</style>